import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Select, Table, Drawer, Tooltip, Dropdown,
} from 'antd';
import {
  EditOutlined, EyeFilled, CaretDownFilled, FilterOutlined,
} from '@ant-design/icons';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import ProductActions from '@Actions/productActions';
import TenantActions from '@Actions/tenantActions';
import searchIcon from '@Images/icons/icon-search.png';
import imageDefault from '@Images/icons/imageDefault.png';
import closeIcon from '@Images/icons/icon-close-blue.png';
import Helpers from '@Apis/helpers';
import Constants, { QUANTITY } from '@Apis/constants';
import AnalyticsActions from '@Actions/application/analyticsActions';

import ProductForm from '../../Common/ProductForm';
import CategoryFilter from '../../Common/CategoryFilter';
import './style.scss';
import CategoryFilterNew from '../../Common/CategoryFilterNew';
import PRZSelect from '../../Common/UI/PRZSelect';

const { Option } = Select;

/**
 *
 */
class ProductsList extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      keyword: '',
      isArchive: 'false',
      showUpdateProductModal: false,
      selectedSkuProduct: {},
      selectedRowKeys: [],
      selectedRows: [],
      productListColumns: [
        {
          title: '',
          render: (text, record) => (
            record?.assets?.[0]?.url
              ? <H3Image src={record?.assets?.[0].url} className="prod-table__image" />
              : <H3Image src={imageDefault} className="prod-table__image prod-table__image__default" />
          ),
          width: '60px',
        },
        {
          title: 'PRODUCT NAME',
          render: (text, record) => (
            <div style={{ maxWidth: '450px' }}>
              <H3Text
                text={record?.internal_sku_code}
                className="prod-table__text"
                style={{ color: 'rgb(45, 125, 247)' }}
              />
              <div style={{ fontFamily: 'Poppins', marginBottom: '1px' }}>{record?.product_sku_name}</div>
              <H3Text text={record?.ref_product_code || ''} className="table-subscript" />
              {(record?.product_type !== 'STORABLE' && record.product_type) && (
                <div className="inventory-qr__status" style={{ backgroundColor: Helpers.getProductType(record?.product_type)?.color }}>{Helpers.getProductType(record?.product_type)?.text}</div>
              )}
              {record?.product_category_info?.category_path && (
                <Tooltip
                  overlay={(
                    <div
                      style={{
                        color: 'rgb(0, 0, 0)',
                        fontSize: '12px',
                        fontWeight: '500',
                        padding: '2px',
                      }}
                    >
                      {record.product_category_info.category_path.join(' / ')}
                    </div>
                  )}
                  color="rgb(234, 242, 254)"
                >
                  {' '}
                  {/* Tooltip wrapping the div */}
                  <div
                    className="inventory-qr__status"
                    style={{ backgroundColor: '#3aa5a6' }}
                  >
                    {/* Displaying only the last category name with ellipsis if path is long */}
                    {record?.product_category_info ? (
                      `.../${record?.product_category_info?.product_category_name}`
                    ) : (
                      ''
                    )}
                  </div>
                </Tooltip>
              )}
            </div>
          ),
        },
        {
          title: 'LOCATIONS',
          render: (text, record) => (
            <H3Text text={record?.tenant_products?.length || '0'} className="prod-table__text" />
          ),
        },
        {
          title: 'BARCODE',
          responsive: ['sm', 'md', 'lg', 'xxl'],
          render: (text, record) => <H3Text text={record?.barcode || ''} className="prod-table__text" />,
        },
        {
          title: 'TOTAL STOCK',
          render: (text, record) => {
            let totalStock = 0;
            for (let i = 0; i < record?.tenant_products?.length; i++) {
              const tenantProduct = record?.tenant_products[i];
              for (let j = 0; j < tenantProduct?.available_stock?.length; j++) {
                totalStock += Helpers.getValueTotalInObject(tenantProduct?.available_stock[j]?.batches, 'available_qty');
              }
            }
            return (
              <div className={totalStock > 0 ? 'avl-stock-product' : 'low-stock-product'}>
                <H3Text
                  text={(
                    <div className="flex-display">
                      <div className="prod-table__text">{`${QUANTITY(totalStock, record?.precision)} ${record?.uqc?.toProperCase()}`}</div>
                      {totalStock > 0 && <EyeFilled onClick={() => this.setState({ showProductOffersSlider: true, selectedVendorProduct: record })} />}
                    </div>
                  )}
                  className="prod-table__text-wrapper"
                />
              </div>
            );
          },
        },
        {
          title: 'LOCATIONS RUNNING LOW',
          render: (text, record) => (
            <H3Text text={record?.tenant_products?.filter((item) => (Number(item?.available_qty) - Number(item?.threshold_qty)) < 0)?.length || '0'} className="prod-table__text" />
          ),
        },
        {
          title: '',
          key: 'action',
          render: (text, record) => {
            const {
              user, getProductById,
            } = this.props;
            return (
              <div className=""
              >
                {Helpers.getPermission(Helpers.permissionEntities.PRODUCT,
                  Helpers.permissionTypes.UPDATE, user) && this.state.selectedRows?.length === 0 && (
                  <div
                    className="roundIconButton"
                    onClick={() => {
                      getProductById(user?.tenant_info?.tenant_id, record.product_sku_id, Helpers.getTenantDepartmentId(user), (productData) => {
                        const newRecord = {
                          ...record,
                          is_uom_editable: productData?.is_uom_editable,
                        };
                        this.setState({
                          showUpdateProductModal: true,
                          selectedSkuProduct: newRecord,
                          showProductOffersSlider: false,
                        });
                      });
                    }}
                  >
                    <EditOutlined />
                  </div>
                )}
              </div>
            );
          },
        },
      ],
      mobileProductLength: 10,
    };
  }

  /**
   *
   */

  /**
   *
   * @param props
   * @param state
   * @return {{isUserReady}|*|(*&{isUserReady: boolean})}
   */
  static getDerivedStateFromProps(props, state) {
    if (props.user && !state.isUserReady) {
      const { getOrgProducts, getTenants } = props;
      getOrgProducts(props.user?.tenant_info?.org_id, null, 1, 10, '', '', Helpers.getTenantDepartmentId(props?.user), '', '', '', '', '', 'false');
      getTenants(1, '', true, props?.user?.tenant_info?.org_id, 100, () => { });
      return {
        ...state,
        isUserReady: true,
      };
    }
    return state;
  }

  /**
   *
   * @param record
   * @return {{className: string, label: string}}
   */
  getStockStatus(record) {
    if (record?.available_qty >= record?.threshold_qty && (record?.threshold_qty !== 0)) {
      return { label: 'Well Stocked', className: 'product_stock-status__stocked' };
    }
    if (record?.available_qty > record?.threshold_qty && (record?.threshold_qty === 0)) {
      return { label: 'Well Stocked', className: 'product_stock-status__stocked' };
    }
    if ((record?.available_qty < record?.threshold_qty) && record?.available_qty > 0) {
      return { label: 'Running Low', className: 'product_stock-status__low' };
    }
    return { label: 'Out of Stock', className: 'product_stock-status__ooo' };
  }

  /**
   * @param record
   */
  getStatusBackgroundColor(record) {
    if (record?.available_qty >= record?.threshold_qty && (record?.threshold_qty !== 0)) {
      return 'rgba(110,220,36,0.1)';
    }
    if (record?.available_qty > record?.threshold_qty && (record?.threshold_qty === 0)) {
      return 'rgba(110,220,36,0.1)';
    }
    if ((record?.available_qty < record?.threshold_qty) && record?.available_qty > 0) {
      return '#2d7df71a';
    }
    return 'rgba(247,45,45,0.05)';
  }

  /**
   * @param data
   */
  getFilteredIndentColumn = (data) => {
    const { user } = this.props;
    const inventoryConfig = user?.tenant_info?.inventory_config;
    const departmentLevelStock = inventoryConfig?.settings?.department_level_stock;
    const showStockToOtherDepartment = inventoryConfig?.settings?.show_stock_to_other_department;
    if (departmentLevelStock) {
      if (showStockToOtherDepartment) {
        return data;
      }
      return data?.filter((item) => item.title !== 'STORE STOCK');
    }
    return data?.filter((item) => (item.title !== 'My Stock'));
  }

  getProductsWithKey = (productsData) => {
    const productsCopy = JSON.parse(JSON.stringify(productsData));
    for (let i = 0; i < productsCopy?.length; i++) {
      productsCopy[i].key = i;
    }
    return productsCopy;
  };

  /**
   *
   * @return {JSX.Element}
   */
  render() {
    const {
      orgProducts, getOrgProductsLoading, getOrgProducts, user, getCartLoading,
      commonGetRequests,
    } = this.props;
    const {
      currentPage, productListColumns, keyword, searchKeyword, showAddProductModal, showUpdateProductModal, selectedSkuProduct,
      showProductOffersSlider, selectedVendorProduct, selectedStatus, selectedTenantId, selectedType, selectedCategory, isArchive, selectedRowKeys, selectedRows,
    } = this.state;

    const productTypeOptions = [
      { label: 'All Types', value: '', key: '' },
      // { label: 'Kit', value: 'KIT', key: 'KIT' }, // Uncomment if needed
      { label: 'Service', value: 'SERVICE', key: 'SERVICE' },
      { label: 'Storable', value: 'STORABLE', key: 'STORABLE' },
    ];

    const archiveOptions = [
      { label: 'Active', value: 'false', key: 'ARCHIVE' },
      { label: 'Archived', value: 'true', key: 'UN_ARCHIVE' },
    ];

    return (
      <Fragment>
        <Drawer
          open={showAddProductModal}
          width="720px"
          mask
          destroyOnClose
          onClose={() => this.setState({ showAddProductModal: false })}
        >
          <div className="custom-drawer__header-wrapper">
            <div className="custom-drawer__header">
              <H3Text text="Add New Product" className="custom-drawer__title" />
              <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => this.setState({ showAddProductModal: false })} />
            </div>
          </div>
          <ProductForm
            callback={
              () => {
                getOrgProducts(user?.tenant_info?.org_id, selectedTenantId, currentPage, 10, '', '', Helpers.getTenantDepartmentId(user), '', '', '', '', '', isArchive);
                this.setState({ showAddProductModal: false });
              }
            }
            isAdmin
          />
        </Drawer>
        <Drawer
          open={showUpdateProductModal}
          width="720px"
          mask
          onClose={() => this.setState({ showUpdateProductModal: false })}
          destroyOnClose
        >
          <div className="custom-drawer__header-wrapper">
            <div className="custom-drawer__header">
              <H3Text text="Update Product" className="custom-drawer__title" />
              <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => this.setState({ showUpdateProductModal: false })} />
            </div>
          </div>
          <ProductForm
            callback={
              () => {
                this.setState({ showUpdateProductModal: false });
                getOrgProducts(user?.tenant_info?.org_id, selectedTenantId, currentPage, 10, '', '', Helpers.getTenantDepartmentId(user), '', '', '', '', '', isArchive);
              }
            }
            selectedSkuProduct={selectedSkuProduct}
            isAdmin
          />
        </Drawer>
        <div className="doc-list__wrapper">
          <div className="ant-row">
            <div className={showProductOffersSlider === true ? 'ant-col-md-24' : 'ant-col-md-24 ant-col-xs-24'}>
                <div className="doc-list__header-wrapper">
                  <div className="doc-list__header-wrapper__left">
                    <div className="section-search">
                      <div className="doc-list__search-bar__wrapper">
                        <div className="section-search-bar">
                          <input
                            value={keyword}
                            placeholder="Search for product name.."
                            onKeyDown={(e) => {
                              if (e.key === 'Enter') {
                                this.setState({ searchKeyword: e.target.value, currentPage: 1 });
                                getOrgProducts(user?.tenant_info?.org_id, selectedTenantId, 1, 10, e.target.value, selectedStatus, Helpers.getTenantDepartmentId(user), null, selectedType, selectedCategory, '', '', isArchive);
                              }
                            }}
                            onChange={(event) => this.setState({ keyword: event.target.value })}
                          />
                          <H3Image
                            src={searchIcon}
                            className="section-search-bar__icon"
                            alt="search"
                            onClick={() => {
                              getOrgProducts(user?.tenant_info?.org_id, selectedTenantId, 1, 10, keyword, '', Helpers.getTenantDepartmentId(user), null, selectedType, selectedCategory, '', '', isArchive);
                              this.setState({ searchKeyword: keyword });
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="doc-list__header-wrapper__right">
                    {Helpers.getPermission(Helpers.permissionEntities.PRODUCT,
                      Helpers.permissionTypes.CREATE, user) && (
                        <div className="doc-list__buttons-wrapper">
                          <H3Button
                            buttonType={defaultButtonTypes.BLUE_ROUNDED}
                            text="+ Add Product"
                            onClick={() => {
                              this.setState({ showAddProductModal: true });
                            }}
                            customClass="add-button"
                          />
                        </div>
                      )}
                  </div>
                </div>
                  {searchKeyword && searchKeyword.length > 0 && (
                    <div className="search-bar__search-container__clear-button">
                      <H3Text
                        text={(
                          <React.Fragment>
                            Showing search results for&nbsp;
                            <i>
                              <b>
                                {`'${searchKeyword}'`}
                              </b>
                            </i>
                          </React.Fragment>
                        )}
                        className="section-search-keyword"
                      />
                      <H3Text
                        text="clear"
                        className="search-bar__clear-button"
                        onClick={() => {
                          this.setState({ searchKeyword: '', keyword: '' });
                          getOrgProducts(user?.tenant_info?.org_id, selectedTenantId, currentPage, 10, '', '', Helpers.getTenantDepartmentId(user), null, selectedType, selectedCategory, '', '', isArchive);
                        }}
                      />
                    </div>
                  )}
                  <div className="doc-list__table-wrapper">
                    <Table
                      title={() => (
                        <div className="doc-list__table-header">
                          <div className="doc-list__table-header__left">
                           <H3Text text={`${(orgProducts && orgProducts.count) ? orgProducts.count : '0'} Products In Your Inventory`} className="" />
                          </div>
                          <div className="doc-list__table-header__right">
                            <div className="doc-list__filter-buttons">
                              {selectedRowKeys?.length > 0 && (
                                <Dropdown
                                  overlay={(
                                    <div className="custom-columns__sort-filter">
                                      <H3Text
                                        text={(isArchive == 'true' || isArchive == true) ? 'Activate' : 'Archive'}
                                        className="header__custom-dropdown__option"
                                        onClick={() => {
                                          const selectedIds = selectedRows?.map((item) => item?.product_sku_id);
                                          const apiUrl = (isArchive === 'true' || isArchive === true) ? Constants.UNARCHIVE_PRODUCTS : Constants.ARCHIVE_PRODUCTS;
                                          commonGetRequests({
                                            url: `${apiUrl}?product_sku_ids=${selectedIds}`,
                                          }, () => {
                                            this.setState({ selectedRows: [], selectedRowKeys: [] });
                                            getOrgProducts(user?.tenant_info?.org_id, selectedTenantId, 1, 10, searchKeyword, '', Helpers.getTenantDepartmentId(user), null, selectedType, selectedCategory, '', '', isArchive);
                                          });
                                        }}
                                      />
                                    </div>
                                  )}
                                  trigger={['click']}
                                  placement="bottomRight"
                                >
                                  <div className="action-buttons">
                                    <div className="action-button">
                                      <H3Text text="Actions" className="action-button-text" />
                                      <CaretDownFilled />
                                    </div>
                                  </div>
                                </Dropdown>
                              )}
                              <Dropdown
                                trigger={['click']}
                                overlay={(
                                  <div className="header__filter__container">
                                    <div className="header__filter__container__title">
                                      Apply Filters
                                    </div>
                                    <div className="filter__container inventory__header__section-status filter__container-section">
                                      <div className="filter__title"> Product Type </div>
                                      <PRZSelect
                                        value={selectedType}
                                        onChange={(value) => {
                                          this.setState({ selectedType: value, currentPage: 1 });
                                          getOrgProducts(user?.tenant_info?.org_id, selectedTenantId, 1, 10, '', '', Helpers.getTenantDepartmentId(user), null, value, selectedCategory, '', '', isArchive);
                                        }}
                                        placeholder="Stock Type"
                                        options={productTypeOptions}
                                      />
                                    </div>
                                    <div className="filter__container inventory__header__section-status filter__container-section">
                                      <div className="filter__title"> Product Category </div>
                                      <CategoryFilterNew
                                        containerClassName="section-status"
                                        hideTitle
                                        placeholder="Product Category"
                                        style={{
                                          width: '100%',
                                          height: '35px',
                                          border: 'none',
                                          borderRadius: '5px',
                                        }}
                                        onChange={(value) => {
                                          this.setState({ selectedCategory: value, page: 1 });
                                          getOrgProducts(user?.tenant_info?.org_id, selectedTenantId, 1, 10, '', '', Helpers.getTenantDepartmentId(user), null, selectedType, value, '', '', isArchive);
                                        }}
                                        isFilter
                                      />
                                    </div>
                                    <div className="filter__container inventory__header__section-status filter__container-section">
                                      <div className="filter__title"> Product Status</div>
                                      <PRZSelect
                                        value={isArchive}
                                        onChange={(value) => {
                                          this.setState({ isArchive: value, currentPage: 1 });
                                          getOrgProducts(user?.tenant_info?.org_id, selectedTenantId, 1, 10, '', '', Helpers.getTenantDepartmentId(user), null, selectedType, selectedCategory, '', '', value);
                                        }}
                                        options={archiveOptions}
                                      />
                                    </div>
                                  </div>
                                )}
                              >
                                <div className="action-buttons">
                                  <div className="action-button">
                                    <H3Text text="Filters" className="action-button-text" />
                                    <FilterOutlined />
                                  </div>
                                </div>
                              </Dropdown>
                            </div>
                          </div>
                        </div>
                      )}
                      loading={getOrgProductsLoading || getCartLoading}
                      showHeader
                      size="small"
                      scroll="scroll"
                      columns={productListColumns && this.getFilteredIndentColumn(productListColumns)}
                      dataSource={orgProducts?.products ? this.getProductsWithKey(orgProducts?.products) : []}
                      pagination={orgProducts?.count > 10 ? {
                        defaultCurrent: 1,
                        total: orgProducts ? orgProducts.count : 0,
                        pageSize: 10,
                        position: ['bottomRight'],
                        showSizeChanger: false,
                        onChange: (page) => {
                          this.setState({ showProductOffersSlider: false, currentPage: page });
                          // eslint-disable-next-line max-len
                          getOrgProducts(user?.tenant_info?.org_id, selectedTenantId, page, 10, searchKeyword, selectedStatus, Helpers.getTenantDepartmentId(user), null, selectedType, selectedCategory, '', '', isArchive);
                        },
                      } : false}
                      rowClassName={(item) => (selectedVendorProduct?.product_sku_id === item?.product_sku_id ? 'admin-inventory__table__selected-row' : '')}
                      rowSelection={(window.screen.width > 325) ? {
                        onChange: (rowKeys, rows) => {
                          this.setState({ selectedRowKeys: rowKeys });
                          this.setState({ selectedRows: rows });
                        },
                        selectedRowKeys,
                      } : false}
                    />
                  </div>
            </div>
            <Drawer
              placement="right"
              onClose={() => this.setState({ showProductOffersSlider: false, selectedVendorProduct: null })}
              open={showProductOffersSlider}
              width="360px"
              destroyOnClose
            >
              <div className="custom-drawer__header-wrapper">
                <div className="custom-drawer__header" style={{ width: '310px' }}>
                  <H3Text text="Available Quantity at All Locations" className="custom-drawer__title" />
                  <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => this.setState({ showProductOffersSlider: false })} />
                </div>
              </div>
              <div className="admin-inventory__slider">
                <div className="admin-inventory__slider__body">
                  {selectedVendorProduct?.tenant_products?.sort((a, b) => Number(b.available_qty) - Number(a.available_qty))
                    ?.map((item) => (
                      // eslint-disable-next-line no-nested-ternary
                      <div key={item?.tenant_id} className="admin-inventory__slider__vendor" style={{ backgroundColor: this.getStatusBackgroundColor(item) }}>
                        <div className="" style={{ width: '100%' }}>
                          <div className="inventory-slider__stock-status-wrapper">
                            <div className="inventory-slider__vendor-name">
                              {item?.tenant_name}
                            </div>
                            <H3Text text={this.getStockStatus(item).label} className={`${this.getStockStatus(item)?.className} inventory-slider__stock-status`} />
                          </div>
                          {item?.available_stock?.length && (
                            <div className="inventory-slider__dept-data">
                              {
                                item?.available_stock?.map((dept) => (
                                  <div className="inventory-slider__dept-row">
                                    <H3Text text={dept?.department_name} className="inventory-slider__dept-name" />
                                    <H3Text
                                      text={`${QUANTITY(Helpers.getValueTotalInObject(dept?.batches, 'available_qty'), selectedVendorProduct?.precision)} ${selectedVendorProduct?.uqc?.toProperCase() || ''}`}
                                      className="inventory-slider__dept-qty"
                                    />
                                  </div>
                                ))
                              }
                            </div>
                          )}
                          <div className="inventory-slider__vendor-price-wrapper" />
                          <div className="inventory-slider__total-stock">{`Total Available Stock - ${QUANTITY(item?.available_qty, selectedVendorProduct?.precision)} ${selectedVendorProduct?.uqc?.toProperCase()}`}</div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </Drawer>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  UserReducers, ProductReducers, SellerReducers, OfferReducers, CartReducers,
}) => ({
  user: UserReducers.user,
  orgProducts: ProductReducers.orgProducts,
  getOrgProductsLoading: ProductReducers.getOrgProductsLoading,
  getSellersLoading: SellerReducers.getSellersLoading,
  sellers: SellerReducers.sellers,
  updateSellerOffersLoading: SellerReducers.updateSellerOffersLoading,
  addProductVendorLoading: ProductReducers.addProductVendorLoading,
  productOffers: ProductReducers.productOffers,
  getOffersLoading: OfferReducers.getOffersLoading,
  offers: OfferReducers.offers,
  cart: CartReducers.cart,
  getCartLoading: CartReducers.getCartLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getProductById: (tenantId, productSkuId, tenantDepartmentId, callback) => dispatch(ProductActions.getProductById(tenantId, productSkuId, tenantDepartmentId, callback)),
  getOrgProducts: (orgId, tenantId, page, limit, keyword, stockStatus, tenantDepartmentId, productSkuId, productType, category, isSalesProduct, isPurchaseProduct, isArchive) => dispatch(ProductActions.getOrgProducts(orgId, tenantId, page, limit, keyword, stockStatus, tenantDepartmentId, productSkuId, productType, category, isSalesProduct, isPurchaseProduct, isArchive)),
  getTenants: (page, keyword, isVerified, orgId, limit, callback) => dispatch(TenantActions.getTenants(page, keyword, isVerified, orgId, limit, callback)),
  commonGetRequests: (payload, callback) => dispatch(AnalyticsActions.commonGetRequests(payload, callback)),
});

ProductsList.propTypes = {
  getOrgProducts: PropTypes.func,
  getOrgProductsLoading: PropTypes.bool,
  orgProducts: PropTypes.any,
  user: PropTypes.any,
  getCartLoading: PropTypes.bool,
  getTenants: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ProductsList));
